import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import loadData from "../data";
import ErrorBoundary from "@Components/ErrorBoundary";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import fetchHomePageData from "../data/fetchHomePageData";
import useWhitelabel from "hooks/useWhitelabel";

const HomeDesktop = loadable(() => import("./HomeDesktop"), {
  fallback: <FullPageLoader />,
});

const WhitelabelHomeDesktop = loadable(
  () => import("@Pages/WhitelabelHome/Desktop/WhitelabelHomeDesktop"),
  {
    fallback: <FullPageLoader />,
  },
);
export default (props: any): JSX.Element => {
  const dispatch = useDispatch();
  const { isWhitelabel } = useWhitelabel();

  useEffect(() => {
    dispatch(fetchHomePageData(props));
  }, []);

  return (
    <ErrorBoundary>{isWhitelabel ? <WhitelabelHomeDesktop /> : <HomeDesktop />}</ErrorBoundary>
  );
};
export { loadData };
